// aspect ratio as per design
export const IMAGE_ASPECT_RATIO = 0.75;
